export const australiaSelectBoxOptions = [
  { key: 'ACT', label: 'ACT', value: 'AB' },
  { key: 'JBT', label: 'JBT', value: 'JBT' },
  { key: 'NSW', label: 'NSW', value: 'NSW' },
  { key: 'NT', label: 'NT', value: 'NT' },
  { key: 'QLD', label: 'QLD', value: 'QLD' },
  { key: 'SA', label: 'SA', value: 'SA' },
  { key: 'TAS', label: 'TAS', value: 'TAS' },
  { key: 'VIC', label: 'VIC', value: 'VIC' },
  { key: 'WA', label: 'WA', value: 'WA' },
];
